import { Fragment, useEffect, useState } from 'react';
import * as i18n from 'i18next';
import { LANGUAGE_CODE_KEY } from '../../utils/constants';

const EURtoBGN = 1.95583;
const EURPriceColor = '#615c5c';

const SubscriptionCard = ({ plan, onClick, isSelected, withDescription }) => {
  const durationNumber = +plan.product.metadata.for;
  const durationText =
    durationNumber === 1
      ? `${i18n.t('payments:month')}`
      : `${i18n.t('payments:months')}`;
  const price = (+plan.unitAmount / 100).toFixed(2);
  const pricePerMonth = (price / durationNumber).toFixed(2);
  const standartPrice = plan.product.metadata.standartPrice;
  const discount = Math.round(
    ((standartPrice * durationNumber - price) /
      (standartPrice * durationNumber)) *
      100
  );
  const [isClicked, setIsClicked] = useState(false);

  const selectPlan = () => {
    setIsClicked(!isClicked);
    if (onClick) onClick(plan.id);
  };

  const renderCardWithDiscount = () => {
    return (
      <div className="card-container">
        <div
          className={`discount-container board brd-rds10 ${
            isSelected && 'selected-discount'
          }`}
        >
          <div className="discount">
            {i18n.t('payments:save')} {discount}%
          </div>
          <div
            className={`subscription-card brd-rds10 ${
              isSelected && 'selected-card'
            }`}
            onClick={selectPlan}
          >
            <div className="package">{i18n.t('payments:package')}</div>
            <div
              className="duration-number"
              style={
                plan.metadata.language === 'bg'
                  ? { fontSize: '22px', height: '25px', marginTop: '-6px' }
                  : {}
              }
            >
              {durationNumber}
            </div>
            <div
              className="duration-text"
              style={
                plan.metadata.language === 'bg'
                  ? { fontSize: '9px', marginBottom: '13px' }
                  : {}
              }
            >
              {durationText}
            </div>
            <div
              className="price"
              style={
                plan.metadata.language === 'bg'
                  ? {
                      lineHeight: '23px',
                      fontSize: '18px',
                      marginBottom: '13px',
                    }
                  : {}
              }
            >
              <p style={{ margin: 0 }}>
                {plan.metadata.language === 'bg'
                  ? `${price} €`
                  : `${price} ${i18n.t('payments:currency')}`}
              </p>

              {plan.metadata.language === 'bg' && (
                <div style={{ color: EURPriceColor, fontWeight: '500' }}>
                  {`${(price * EURtoBGN).toFixed(2)} ${i18n.t(
                    'payments:currency'
                  )}`}
                </div>
              )}
            </div>
            <div className="price-per-month">
            <p style={{ margin: 0 }}>
              {plan.metadata.language === 'bg'
                ? `${pricePerMonth} €/ ${i18n.t('payments:month')}`
                : `${pricePerMonth} ${i18n.t('payments:currency')}/ ${i18n.t(
                   'payments:month'
              )}`}
              </p>
            </div>
          </div>
        </div>
        {withDescription && (
          <div className="plan-description">
            {`${price} € `}
            {plan.metadata.language === 'bg' && (
              <>
                <span>{`/ ${(price * EURtoBGN).toFixed(2)} ${i18n.t(
                  'payments:currency'
                )}`}</span>
              </>
            )}
            {i18n
              .t('payments:singlePaymentDescription')
              .split('\n')
              .map((line, index) => (
                <Fragment key={index}>
                  {line}
                  <br />
                </Fragment>
              ))}
          </div>
        )}
      </div>
    );
  };

  const renderCardWithNoDiscount = () => {
    return (
      <div className="card-container">
        <div className="discount hidden">
          {i18n.t('payments:save')} {discount}%
        </div>
        <div
          className={`subscription-card-no-discount board brd-rds10 ${
            isSelected && 'selected-card'
          }`}
          onClick={selectPlan}
        >
          <div className="package hidden">{i18n.t('payments:package')}</div>
          <div className="monthly-duration">
            {i18n.t('payments:monthly')}
            <br />
            {i18n.t('payments:subscription')}
          </div>
          <div className="duration-text hidden">{durationText}</div>
          <div className="price hidden">
            {plan.metadata.language === 'bg'
              ? `${price} €`
              : `${price} ${i18n.t('payments:currency')}`}
          </div>
          <div className="price-per-month">
          <p style={{ margin: 0 }}>
            {plan.metadata.language === 'bg'
              ? `${pricePerMonth} €/ ${i18n.t('payments:month')}`
              : `${pricePerMonth} ${i18n.t('payments:currency')}/ ${i18n.t(
                 'payments:month'
            )}`}
          </p>
            {plan.metadata.language === 'bg' && (
              <div style={{ color: EURPriceColor, fontWeight: '500' }}>
                {`${(pricePerMonth * EURtoBGN).toFixed(2)} ${i18n.t(
                  'payments:currency'
                )}/ ${i18n.t('payments:month')}`}
              </div>
            )}
          </div>
        </div>
        <div className="plan-description">
        {plan.metadata.language === 'bg'
          ? `${price} € `
          : `${price} ${i18n.t('payments:currency')} `}
          {plan.metadata.language === 'bg' && (
            <span>{`/ ${(price * EURtoBGN).toFixed(2)} ${i18n.t(
              'payments:currency'
            )}`}</span>
          )}
          {i18n
            .t('payments:subscriptionDescription')
            .split('\n')
            .map((line, index) => (
              <Fragment key={index}>
                {line}
                <br />
              </Fragment>
            ))}
        </div>
      </div>
    );
  };

  const renderActivePlan = () => {
    const language = localStorage.getItem(LANGUAGE_CODE_KEY);
    const isLanguageBG = language === 'bg';

    return (
      <div className="card-container">
        <div
          className="subscription-card-no-discount board brd-rds10 selected-card active"
          onClick={selectPlan}
        >
          {discount === 0 ? (
            <>
              <div className="package hidden">{i18n.t('payments:package')}</div>
              <div className="monthly-duration">
                {i18n.t('payments:monthly')}
                <br />
                {i18n.t('payments:subscription')}
              </div>
              <div className="duration-text hidden">{durationText}</div>
              <div className="price hidden">
                {plan.metadata.language === 'bg'
                  ? `${price} €`
                  : `${price} ${i18n.t('payments:currency')}`}
              </div>
            </>
          ) : (
            <>
              <div className="package">{i18n.t('payments:package')}</div>
              <div className="duration-number">{durationNumber}</div>
              <div className="duration-text">{durationText}</div>
              <div className="price">
                <p style={{ margin: 0 }}>{`${price} €`}</p>
                {isLanguageBG && (
                  <div style={{ color: EURPriceColor, fontWeight: '500' }}>
                    {`${(price * EURtoBGN).toFixed(2)} ${i18n.t(
                      'payments:currency'
                    )}`}
                  </div>
                )}
              </div>
            </>
          )}
          <div className="price-per-month">
          <p style={{ margin: 0 }}>
            {plan.metadata.language === 'bg'
              ? `${pricePerMonth} €/ ${i18n.t('payments:month')}`
              : `${pricePerMonth} ${i18n.t('payments:currency')}/ ${i18n.t(
                'payments:month'
            )}`}
          </p>
            {isLanguageBG && (
              <div style={{ color: EURPriceColor, fontWeight: '500' }}>
                {`${(pricePerMonth * EURtoBGN).toFixed(2)} ${i18n.t(
                  'payments:currency'
                )}/ ${i18n.t('payments:month')}`}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return !withDescription
    ? renderActivePlan()
    : discount
    ? renderCardWithDiscount()
    : renderCardWithNoDiscount();
};

export default SubscriptionCard;
